module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-reel-feedback"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "feedback"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.feedback.text),
      expression: "feedback.text"
    }],
    attrs: {
      "placeholder": 'Please provide feedback for ' + _vm.student.firstName + ' ' + _vm.student.lastName + '\'s progress this week, which they will review'
    },
    domProps: {
      "value": (_vm.feedback.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.feedback.text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('dropzone', {
    ref: "feedbackFiles",
    attrs: {
      "id": "feedbackFiles",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 0,
      "dropzone-options": _vm.dropzoneOptions
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitFeedback()
      }
    }
  }, [_vm._v("Send Feedback")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7077f0cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/DemoReelFeedback.vue
// module id = 2047
// module chunks = 2